import { gql } from '__generated__';

export const GET_TENANT = gql(/* GraphQL */ `
  query getTenant($id: Int!) {
    tenant(id: $id) {
      id
      name
      timezone
      ...TenantConfig
    }
  }
`);
